import grey from '@material-ui/core/colors/grey'

export const styles = theme => ({
  container: {
    width: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: theme.spacing.unit * 4,
    backgroundColor: grey['200']
  },

  emptyBookingsCell: {
    textAlign: 'center',
    fontSize: '1rem'
  }
})



// WEBPACK FOOTER //
// ./src/components/BlacklistBookings/styles.js